module.exports = __webpack_public_path__ + "od-instagram/od-instagram-72d2e914ceb4e5aff9b9d45751177035.svg";